import { DateNavigator } from '@parsina/framework';
import { useTranslation } from '../i18n';

/**
 * The day stepper that lives inside the gradient header.
 *
 * Its rule is that arrow-stepping is never the ONLY path to a date: tapping
 * the label opens a Jalali calendar in a sheet. A receptionist asked for «next
 * Tuesday» should not press an arrow five times, and a month away is not
 * reachable at all that way.
 *
 * Every label is a required prop on the kit component and none of them
 * defaults to Persian — the kit ships no translation catalogue, and a Persian
 * default is exactly the bug that shows «امروز» inside an English panel. The
 * Jalaali formatting of `dateLabel` stays with the app for the same reason:
 * the calendar is the clinic's, whatever language the chrome is in.
 */
export default function MobileDateBar({ value, onChange, dateLabel, subLabel, isToday, onPrev, onNext, onToday }) {
  const { t } = useTranslation();
  return (
    <DateNavigator
      value={value}
      onChange={onChange}
      dateLabel={dateLabel}
      subLabel={subLabel}
      isToday={isToday}
      onPrev={onPrev}
      onNext={onNext}
      onToday={onToday}
      prevLabel={t('reception.dayNav.previous')}
      nextLabel={t('reception.dayNav.next')}
      pickLabel={t('reception.dayNav.pickDate')}
      todayLabel={t('reception.dayNav.today')}
      sheetTitle={t('reception.dayNav.pickDate')}
      closeLabel={t('common.actions.close')}
      variant="onGradient"
    />
  );
}
